"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryTableApp = void 0;
exports.dashUserToRawEmployment = dashUserToRawEmployment;
exports.sortUsers = sortUsers;
exports.fetchAllUsers = fetchAllUsers;
exports.fetchAllDashSlots = fetchAllDashSlots;
exports.calcSlotMap = calcSlotMap;
exports.dashSlotToShift = dashSlotToShift;
exports.dashSlotToRawShift = dashSlotToRawShift;
exports.filterUsersToWorkerOnly = filterUsersToWorkerOnly;
exports.filterUsersToThoseWithRoleSlot = filterUsersToThoseWithRoleSlot;
exports.filterUsersByTags = filterUsersByTags;
exports.filterUsers = filterUsers;
exports.calcStartDateForSlotFetch = calcStartDateForSlotFetch;
exports.calcUserIdsToFetch = calcUserIdsToFetch;
exports.calcTagsProp = calcTagsProp;
exports.calcAppUserMap = calcAppUserMap;
exports.parseSummaryQueryParams = parseSummaryQueryParams;
exports.decodeTags = decodeTags;
exports.calcDedupedTagsListFromUsers = calcDedupedTagsListFromUsers;
exports.computeEditModeCellProps = computeEditModeCellProps;
exports.computeRoleCountData = computeRoleCountData;
exports.calcSlotsToDelete = calcSlotsToDelete;
const vue_1 = require("vue");
const SummaryTable_vue_1 = __importDefault(require("../view/components/summaryTable/SummaryTable.vue"));
const employmentShiftTable_1 = require("../employmentShiftTable/employmentShiftTable");
const provider_1 = require("../provider/provider");
const summaryTable_1 = require("../presenter/summaryTable");
const summary_1 = require("../requests/summary");
const common_1 = require("../common/common");
const models_1 = require("../js/models");
const luxon_1 = require("luxon");
const shift_1 = require("../view/shift/shift");
const shift_2 = require("../model/v1/shift");
const summary_lib_1 = require("../js/summary_lib");
const shiftStore_1 = require("../store/v1/shiftStore");
const summary_common_1 = require("../js/summary_common");
const viewTypes_1 = __importDefault(require("../table/v1/viewTypes"));
const autoai_poll_1 = require("../view/components/autoAI/autoai_poll");
const common_2 = require("../js/common");
const table_1 = require("../table/v1/table");
const periodTypes_1 = __importDefault(require("../table/v1/periodTypes"));
const IndexedDBStorage_1 = require("../storage/IndexedDBStorage");
const storageSummary_1 = require("../storage/storageSummary");
var DashSlotIndexNames;
(function (DashSlotIndexNames) {
    DashSlotIndexNames["SlotBranchIdFromIndex"] = "slotBranchIdFromIndex";
    DashSlotIndexNames["SlotUserIdFromIndex"] = "slotUserIdFromIndex";
    DashSlotIndexNames["SlotCachedAtIndex"] = "slotCachedAtIndex";
})(DashSlotIndexNames || (DashSlotIndexNames = {}));
var DashUserIndexNames;
(function (DashUserIndexNames) {
    DashUserIndexNames["UserCachedAtIndex"] = "userCachedAtIndex";
})(DashUserIndexNames || (DashUserIndexNames = {}));
// Max entity count in single db. Begin deleting oldest after hitting max.
const MAX_CACHE_SIZE = 30000;
class SummaryTableApp {
    viewApp;
    presenter;
    // Provided by summary_lib. Static values.
    tableDates = [];
    branch;
    settings;
    templates = [];
    roleStore;
    meStore;
    canEdit = false;
    viewType;
    hasAutoPerm = false;
    hasOpenAIPerm = false;
    showMemo = false;
    branchDefaultMaxMonthly;
    roleCountData;
    // Managed by app. Require updates on slot and user changes.
    slotMap = {};
    cellsMap = (0, vue_1.ref)({});
    editModeCellProps = (0, vue_1.ref)({});
    summaryStats;
    employmentStore;
    shiftStore;
    query;
    useSectionWage;
    // Subject-like. Consider read only by any presentation function.
    slots = new Map();
    users = [];
    // Cache
    slotDb;
    userDb;
    slotCacheWorker;
    userCacheWorker;
    // Worker imports don't currently work with FE development server.
    useCacheWorker = process.env.NODE_ENV !== "development";
    // Cache read-only view
    isReadOnly = (0, vue_1.ref)(true);
    constructor(useSectionWage) {
        this.viewApp = (0, vue_1.createApp)(SummaryTable_vue_1.default);
        this.presenter = new summaryTable_1.SummaryTablePresenterImpl();
        this.initPresentation();
        this.query = parseSummaryQueryParams(document.location.search);
        this.viewApp.provide(provider_1.summaryTableCellsMapInjectKey, (0, vue_1.readonly)(this.cellsMap));
        this.viewApp.provide(provider_1.summaryTableSlotMapInjectKey, this.slotMap);
        // Adding readonly(), which stops view from mutating view model, causes ts to report error: is 'readonly' and cannot be assigned to the mutable type 'SummaryTableEmployeeRow[]'.
        // It's a known typescript quirk (https://stackoverflow.com/questions/62225769/inconsistency-with-typescript-readonly-type) but doesn't appear in other repos. I am assuming it's a config issue.
        // Ignoring the typescript check for now as ignoring it makes the view model readonly and there doesn't seem to be any resulting type issues.
        // @ts-ignore
        this.viewApp.provide(provider_1.summaryTableEditModePropsInjectKey, (0, vue_1.readonly)(this.editModeCellProps));
        this.useSectionWage = useSectionWage || false;
    }
    // DEPRECATED. A temporary solution to allow edit mode to access employment store.
    getEmploymentStore() {
        return this.employmentStore;
    }
    setCanEdit(canEdit) {
        this.canEdit = canEdit;
    }
    setBranchDefaultMaxMonthly(max) {
        this.branchDefaultMaxMonthly = max;
    }
    setShowMemo(show) {
        this.showMemo = show;
    }
    setRoleCountData(data) {
        this.roleCountData = data;
    }
    setHasOpenAIPerm(has) {
        this.hasOpenAIPerm = has;
    }
    setHasAutoPerm(has) {
        this.hasAutoPerm = has;
    }
    setViewType(t) {
        this.viewType = t;
    }
    setTemplates(ts) {
        this.templates = ts;
    }
    setTableDates(td) {
        this.tableDates = td;
        this.presenter.initDates(td);
    }
    setBranch(b) {
        this.branch = b;
    }
    async initCache() {
        if (this.useCacheWorker) {
            // @ts-ignore
            // import.meta.url use works but current config throws an error.
            this.slotCacheWorker = new Worker(new URL(/* webpackChunkName: "summarySlotCache.worker" */ "../worker/summarySlotCache.ts", import.meta.url), { type: 'module' });
            this.slotCacheWorker.addEventListener('message', (e) => {
                this.cacheSlotsBatchedBackground(e.data.cursor);
            });
            // @ts-ignore
            // import.meta.url use works but current config throws an error.
            this.userCacheWorker = new Worker(new URL(/* webpackChunkName: "summaryUserCache.worker" */ "../worker/summaryUserCache.ts", import.meta.url), { type: 'module' });
        }
        else {
            console.info("Use synchronous cache puts.");
        }
        try {
            const userDb = new IndexedDBStorage_1.IndexedDBStorage(storageSummary_1.dashUserStore);
            await userDb.init(userDb.dbName);
            await userDb.createIndex(userDb.dbName, {
                name: DashUserIndexNames.UserCachedAtIndex,
                keyPath: "cachedAtMs",
            });
            this.userDb = userDb;
            const slotDb = new IndexedDBStorage_1.IndexedDBStorage(storageSummary_1.dashSlotStore);
            await slotDb.init(slotDb.dbName);
            // Composite index slots by branch id and from ms
            // Allows for a date range query by branch
            await slotDb.createIndex(slotDb.dbName, {
                name: DashSlotIndexNames.SlotBranchIdFromIndex,
                keyPath: ["branchId", "fromMs"]
            });
            // Composite index slots by user id and from ms
            // Allows for a date range query by user id. Required for clones.
            await slotDb.createIndex(slotDb.dbName, {
                name: DashSlotIndexNames.SlotUserIdFromIndex,
                keyPath: ["userId", "fromMs"],
            });
            await slotDb.createIndex(slotDb.dbName, {
                name: DashSlotIndexNames.SlotCachedAtIndex,
                keyPath: "cachedAtMs",
            });
            this.slotDb = slotDb;
        }
        catch (e) {
            console.error(`Failed to init cache: ${e}`);
        }
    }
    async enforceSlotCacheLimit() {
        if (!this.slotDb) {
            return;
        }
        try {
            const size = await this.slotDb.getTotalEntityCount();
            if (size <= MAX_CACHE_SIZE) {
                return;
            }
            const numberDeleted = await this.slotDb.deleteFromIndexAscUntilSize(DashSlotIndexNames.SlotCachedAtIndex, size - MAX_CACHE_SIZE);
            // Index does not contain all entities. Avoid infinite loop.
            if (numberDeleted === 0) {
                return;
            }
            const sizeAfter = await this.slotDb.getTotalEntityCount();
            if (sizeAfter <= MAX_CACHE_SIZE) {
                return;
            }
            this.enforceSlotCacheLimit();
        }
        catch (e) {
            console.error(`Failed to enforce slot cache limit: ${e}`);
        }
    }
    async enforceUserCacheLimit() {
        if (!this.userDb) {
            return;
        }
        try {
            const size = await this.userDb.getTotalEntityCount();
            if (size <= MAX_CACHE_SIZE) {
                return;
            }
            const numberDeleted = await this.userDb.deleteFromIndexAscUntilSize(DashUserIndexNames.UserCachedAtIndex, size - MAX_CACHE_SIZE);
            // Index does not contain all entities. Avoid infinite loop.
            if (numberDeleted === 0) {
                return;
            }
            const sizeAfter = await this.userDb.getTotalEntityCount();
            if (sizeAfter <= MAX_CACHE_SIZE) {
                return;
            }
            this.enforceUserCacheLimit();
        }
        catch (e) {
            console.error(`Failed to enforce user cache limit: ${e}`);
        }
    }
    async getAllSlotsFromCache(branchId, employeeIds, fromGte, fromLt, lockedOnly, roleIds) {
        if (!this.slotDb) {
            return [];
        }
        const oplusTimeFromGte = (0, common_1.toOplusTime)(fromGte);
        const oplusTimeFromLt = (0, common_1.toOplusTime)(fromLt);
        const roleIdSet = new Set(roleIds);
        const lower = [branchId, oplusTimeFromGte.valueOf()];
        const upper = [branchId, oplusTimeFromLt.valueOf()];
        const slots = await this.slotDb.getAllFromIndexInRange(DashSlotIndexNames.SlotBranchIdFromIndex, lower, upper, false, true);
        // If no role filter, fetch clones for employees even if they don't have a slot at current branch.
        const fetchClones = roleIds?.length ? null : employeeIds;
        // Using branch slots from date range, build list of working users
        const userIdSet = new Set(fetchClones);
        for (const s of slots) {
            if ((lockedOnly && !s.isLocked) || (roleIds?.length && !roleIdSet.has(s.roleId))) {
                continue;
            }
            userIdSet.add(s.userId);
        }
        const out = [];
        // Get all slots by user id for date range, including clones
        for await (const userId of userIdSet) {
            const lower = [userId, oplusTimeFromGte.valueOf()];
            const upper = [userId, oplusTimeFromLt.valueOf()];
            const userSlots = await this.slotDb.getAllFromIndexInRange(DashSlotIndexNames.SlotUserIdFromIndex, lower, upper, false, true);
            for (const s of userSlots) {
                if ((lockedOnly && !s.isLocked) || (roleIds?.length && !roleIdSet.has(s.roleId))) {
                    continue;
                }
                out.push(s);
            }
        }
        return out;
    }
    async getUsersForBranchAndUserIdsFromCache(branchId, userIds) {
        if (!this.userDb) {
            return [];
        }
        const out = [];
        for await (const userId of userIds) {
            const u = await this.userDb.get(this.userDb.dbName, (0, storageSummary_1.dashUserCacheId)(branchId, userId));
            if (!u) {
                continue;
            }
            out.push(u);
        }
        return out;
    }
    async getFromCacheAndPresent() {
        if (!this.branch) {
            return;
        }
        let slots = [];
        try {
            const fromGte = this.tableDates[0].getDate();
            const fromLt = new Date(this.tableDates[this.tableDates.length - 1].getEnd().valueOf() + 1);
            slots = await this.getAllSlotsFromCache(this.branch.id, this.branch.employeeIds, fromGte, fromLt, this.query.isLocked, this.query.roleIds);
        }
        catch (e) {
            console.error(`Failed to get slots from cache: ${e}`);
            return;
        }
        // Notify subject
        this.addSlotsToSlotMap(slots);
        let users = [];
        try {
            users = await this.getUsersForBranchAndUserIdsFromCache(this.branch.id, calcUserIdsToFetch(this.branch.employeeIds, slots));
        }
        catch (e) {
            console.error(`Failed to get users from cache: ${e}`);
            return;
        }
        const allUserTags = calcDedupedTagsListFromUsers(users);
        const userTagsFilters = decodeTags(this.query.customEncodingUserTags, allUserTags);
        const filters = {
            roleIds: this.query.roleIds,
            userTags: userTagsFilters,
            isLocked: this.query.isLocked,
            workerOnly: this.query.workerOnly,
        };
        this.presentSlotsAndUsersReadOnly(users, slots, filters);
    }
    async fetchAndPresent() {
        if (!this.branch || !this.settings || !this.roleStore || !this.meStore) {
            return;
        }
        // Controller
        const startDateForFetch = calcStartDateForSlotFetch(this.tableDates[0].getDate(), this.settings.splitNightShift);
        let slots = [];
        try {
            slots = await fetchAllDashSlots(this.branch.id, startDateForFetch, this.tableDates[this.tableDates.length - 1].getEnd(), this.query.roleIds, this.query.isLocked);
        }
        catch (e) {
            alert("シフトの読み込みができませんでした。");
            console.error(e);
            return;
        }
        const slotsToDelete = calcSlotsToDelete(slots, this.slots);
        // Notify subject
        this.addSlotsToSlotMap(slots);
        if (slotsToDelete.length) {
            // Deleting slots not returned from server currently requires manually updating role counts.
            // Can be removed when stats are made into a ref.
            for (const id of slotsToDelete) {
                const s = this.slots.get(id);
                if (s) {
                    this.updateStatsOnRawSlotDelete(dashSlotToRawShift(s, this.settings, this.tableDates[0].getDate(), this.tableDates[this.tableDates.length - 1].getEnd(), this.settings.getTimeZone()));
                }
                this.slots.delete(id);
            }
            this.renderStats();
        }
        // Controller
        let allUsers = [];
        try {
            const userIds = calcUserIdsToFetch(this.branch.employeeIds, slots);
            allUsers = await fetchAllUsers(this.branch.id, userIds);
        }
        catch (e) {
            alert("スタッフの読み込みができませんでした。");
            console.error(e);
            return;
        }
        // Allow slot edits now that we have synced.
        this.isReadOnly.value = false;
        // Notify subject
        this.users = allUsers;
        const allUserTags = calcDedupedTagsListFromUsers(allUsers);
        const userTagsFilters = decodeTags(this.query.customEncodingUserTags, allUserTags);
        const filters = {
            roleIds: this.query.roleIds,
            userTags: userTagsFilters,
            isLocked: this.query.isLocked,
            workerOnly: this.query.workerOnly,
        };
        // Present
        this.presentSlotsAndUsers(allUsers, slots, filters);
        // Do not await.
        this.cacheView();
        this.cleanCacheSlots(slotsToDelete);
        this.enforceSlotCacheLimit();
        this.enforceUserCacheLimit();
    }
    addSlotsToSlotMap(slots) {
        const repeatsMap = new Map();
        for (const s of slots) {
            if (s.isRepeat) {
                // Only store the earliest repeat instance of the current fetch.
                const curFrom = repeatsMap.get(s.id);
                if (curFrom && curFrom < new Date(s.from)) {
                    continue;
                }
                repeatsMap.set(s.id, new Date(s.from));
            }
            this.slots.set(s.id, s);
        }
    }
    async cleanCacheSlots(slotIds) {
        if (!this.slotDb || !slotIds.length) {
            return;
        }
        try {
            await this.slotDb.deleteBatchKeys(slotIds);
        }
        catch (e) {
            console.error(`Failed to clean cache slots: ${e}`);
        }
    }
    async cacheView() {
        if (this.userCacheWorker) {
            const messageData = {
                users: this.users,
            };
            this.userCacheWorker.postMessage(messageData);
        }
        else {
            try {
                // Use main thread put.
                await (0, storageSummary_1.cacheUsers)(this.users);
            }
            catch (e) {
                console.error(`Failed to cache view: ${e}`);
            }
        }
        await this.cacheAllSlots();
    }
    cacheSlotsBatchedBackground(cursor) {
        if (!this.slotCacheWorker) {
            return;
        }
        const messageData = {
            slots: [],
        };
        const allSlots = [];
        for (const [, s] of this.slots) {
            allSlots.push(s);
        }
        allSlots.sort((a, b) => a.id - b.id);
        for (const s of allSlots) {
            // Limit slots passed to background to 300 as any data passed to other thread is copied via structuredClone().
            if (messageData.slots.length >= 300) {
                break;
            }
            if (!cursor || s.id > cursor) {
                messageData.slots.push(s);
                continue;
            }
        }
        if (!messageData.slots.length) {
            return;
        }
        this.slotCacheWorker.postMessage(messageData);
    }
    presentSlotsAndUsersReadOnly(allUsers, slots, filters) {
        if (!this.branch || !this.settings || !this.roleStore || !this.meStore) {
            return;
        }
        const filteredUsers = filterUsers(allUsers, slots, filters.workerOnly ?? false, filters.userTags, filters.roleIds);
        const sortedUsers = sortUsers(filteredUsers, this.branch.employeeIds);
        this.initPresentationEmployeeRows(sortedUsers);
        const rawEmployments = [];
        for (const u of sortedUsers) {
            rawEmployments.push(dashUserToRawEmployment(u));
        }
        // Required for slot modal to fill in user values
        (0, summary_lib_1.setGlobalAppUserMap)(calcAppUserMap(sortedUsers));
        const filteredUserSet = new Set();
        for (const u of filteredUsers) {
            filteredUserSet.add(u.userId);
        }
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        const rawSlots = [];
        for (const s of slots) {
            if (!filteredUserSet.has(s.userId)) {
                continue;
            }
            rawSlots.push(dashSlotToRawShift(s, this.settings, this.tableDates[0].getDate(), endTableDate.getEnd(), this.settings.getTimeZone()));
        }
        const slotMap = calcSlotMap([...rawSlots, ...this.templates]);
        Object.assign(this.slotMap, slotMap);
        (0, summary_lib_1.setSlotMap)(slotMap);
        const cellsMap = {};
        (0, employmentShiftTable_1.buildCellsMap)(cellsMap, slotMap, (0, common_1.toOplusTime)(endTableDate.getDate()), filters.isLocked ?? false, this.settings.splitNightShift, this.settings.getTimeZone());
        this.cellsMap.value = cellsMap;
        this.initStats(rawEmployments, slots);
    }
    presentSlotsAndUsers(allUsers, slots, filters) {
        if (!this.branch || !this.settings || !this.roleStore || !this.meStore) {
            return;
        }
        this.presentSlotsAndUsersReadOnly(allUsers, slots, filters);
        const filteredUsers = filterUsers(allUsers, slots, filters.workerOnly ?? false, filters.userTags, filters.roleIds);
        const filteredUserIds = filteredUsers.map(du => du.userId);
        this.editModeCellProps.value = computeEditModeCellProps(this.tableDates, filteredUserIds, this.settings.getTimeZone());
        const filteredUserSet = new Set(filteredUserIds);
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        const rawSlots = [];
        for (const s of slots) {
            if (!filteredUserSet.has(s.userId)) {
                continue;
            }
            rawSlots.push(dashSlotToRawShift(s, this.settings, this.tableDates[0].getDate(), endTableDate.getEnd(), this.settings.getTimeZone()));
        }
        (0, summary_lib_1.toggleUnlockSlotBtn)(rawSlots);
    }
    renderStats() {
        if (!this.branch) {
            return;
        }
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
    }
    renderDeferrableDOMManipulations(props) {
        if (!this.branch || !this.roleStore || !this.meStore) {
            return;
        }
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        const slots = [];
        for (const [, s] of this.slots) {
            slots.push(s);
        }
        const allUserTags = calcDedupedTagsListFromUsers(this.users);
        const userTagsFilters = decodeTags(this.query.customEncodingUserTags, allUserTags);
        if (this.canEdit && this.viewType === viewTypes_1.default.MONTH) {
            const filters = {
                roleIds: [],
                userTags: userTagsFilters,
                isLocked: this.query.isLocked,
                workerOnly: this.query.workerOnly,
            };
            const filteredUsers = filterUsers(this.users, slots, filters.workerOnly ?? false, filters.userTags, filters.roleIds);
            const sortedUsers = sortUsers(filteredUsers, this.branch.employeeIds);
            const rawEmployments = [];
            for (const u of sortedUsers) {
                rawEmployments.push(dashUserToRawEmployment(u));
            }
            (0, summary_lib_1.initUserMonthlyLaborBadges)(rawEmployments, this.summaryStats, this.meStore, this.employmentStore, this.branchDefaultMaxMonthly);
        }
        // Following should only be inited once we have fresh data.
        // Always include all tags, even for staff not shown.
        const tagsProp = calcTagsProp(allUserTags, userTagsFilters);
        const roles = this.roleStore.query({ isOrRole: true, excludeOrRole: true });
        const oplusTimeStart = (0, common_1.toOplusTime)(this.tableDates[0].getDate());
        const oplusTimeEnd = (0, common_1.toOplusTime)(this.tableDates[this.tableDates.length - 1].getDate());
        (0, summary_lib_1.mountAutoModal)(props, roles, tagsProp);
        if (this.hasAutoPerm && this.hasOpenAIPerm) {
            (0, summary_lib_1.mountAutoAIModal)(props, roles, oplusTimeStart, oplusTimeEnd, tagsProp);
            (0, autoai_poll_1.initFooterAutoButtonClick)();
        }
        (0, summary_lib_1.mountSummaryDateNavView)(props, oplusTimeStart, oplusTimeEnd, tagsProp);
        (0, summary_lib_1.scrollToToday)();
        (0, summary_lib_1.setCalendarModal)();
        (0, common_2.readSlots)(this.slotMap, this.meStore.me.getOriginalId());
    }
    updateStatsOnRawSlotChange(rawSlot) {
        if (!this.shiftStore || !this.summaryStats || !this.branch || !this.settings) {
            return;
        }
        const options = {
            prevShift: getShiftForStatsFromShiftStore(rawSlot.ID, this.shiftStore),
        };
        (0, employmentShiftTable_1.addRawSlotToShiftStore)(rawSlot, this.settings.getTimeZone(), this.tableDates, this.shiftStore, this.branch.id);
        const shift = this.shiftStore.byId(rawSlot.ID.toString());
        if (!shift) {
            return;
        }
        this.summaryStats.handleShiftChange(shift, options);
    }
    addSlotToCellsMapOnRawSlotChange(rawSlot) {
        if (!this.shiftStore || !this.settings) {
            return;
        }
        if (rawSlot.Repeat) {
            (0, employmentShiftTable_1.renderRepeatSlots)(this.cellsMap.value, rawSlot, (0, common_1.toOplusTime)(this.tableDates[this.tableDates.length - 1].getDate()), this.query.isLocked ?? false, this.settings.splitNightShift, this.settings.getTimeZone());
            return;
        }
        const shift = this.shiftStore.byId(rawSlot.ID.toString());
        // Only add shifts are in view.
        if (!shift || !(0, common_2.timespansOverlap)(this.tableDates[0].getDate(), this.tableDates[this.tableDates.length - 1].getEnd(), shift.getStartDate(), shift.getEndDate())) {
            return;
        }
        (0, employmentShiftTable_1.addSlotToCellsMap)(this.cellsMap.value, rawSlot, this.settings.splitNightShift, this.settings.getTimeZone());
    }
    handleSpecialCellsMapConditions(rawSlot, prev) {
        if (!this.settings) {
            return;
        }
        if (this.settings.splitNightShift && prev) {
            // Slot rendering in table when split night shift is on requires extra deletes when overnight slot becomes normal.
            const prevDates = (0, employmentShiftTable_1.getDateStringsForSlot)(prev, this.settings.getTimeZone());
            const curDates = (0, employmentShiftTable_1.getDateStringsForSlot)(rawSlot, this.settings.getTimeZone());
            if (prevDates.length > curDates.length) {
                for (const d of prevDates) {
                    if (this.cellsMap.value[prev.UserID]?.[d]) {
                        delete this.cellsMap.value[prev.UserID][d].slots[prev.ID];
                    }
                }
            }
        }
        // A conversion to a requested slot requires deleting the previous request slot template.
        if (rawSlot.RequestedSlot) {
            const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(rawSlot, this.settings.getTimeZone());
            for (const d of dates) {
                if (this.cellsMap.value[rawSlot.UserID]?.[d]) {
                    delete this.cellsMap.value[rawSlot.UserID][d].slots[rawSlot.RequestedSlot.ID];
                }
            }
        }
    }
    async cacheSlot(s) {
        if (!this.slotDb) {
            return;
        }
        try {
            await this.slotDb.put(new storageSummary_1.DashSlotIndexedDB((0, storageSummary_1.dashSlotToCacheable)(s)));
        }
        catch (e) {
            console.error(`Failed to cache slot: ${e}`);
        }
    }
    // Because slot changes occur outside of app in components like slot modal,
    // handleSlotChange provides a way to pass those slots and update necessary stats and global vars.
    handleRawSlotChange(rawSlot) {
        if (!rawSlot || rawSlot.LinkNext || rawSlot.LinkPrev || !this.shiftStore || !this.branch || !this.settings || !this.summaryStats) {
            return;
        }
        // Update subject
        const ss = rawSlotToDashSlot(rawSlot);
        this.slots.set(ss.id, ss);
        // Present
        this.updateStatsOnRawSlotChange(rawSlot);
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        this.handleSpecialCellsMapConditions(rawSlot, this.slotMap[rawSlot.ID]);
        // Add to slot map.
        this.slotMap[rawSlot.ID] = rawSlot;
        rawSlot.SectionSlots?.forEach(section => {
            this.slotMap[section.ID] = section;
        });
        // Must set global slot map before cells map.
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        this.addSlotToCellsMapOnRawSlotChange(rawSlot);
        (0, summary_lib_1.toggleUnlockSlotBtn)(Object.values(this.slotMap));
        // Do not await.
        this.cacheSlot(ss);
    }
    // DEPRECATED. Linked Slots as a feature are deprecated. Required for overnight role slots.
    handleStatsLinked(rawSlots) {
        if (!this.shiftStore || !this.settings || !this.branch || !this.summaryStats) {
            return;
        }
        let id = rawSlots[0].ID;
        if (!this.shiftStore.byId(rawSlots[0].ID.toString()) && rawSlots[1]) {
            id = rawSlots[1].ID;
        }
        const prev = getShiftForStatsFromShiftStore(id, this.shiftStore);
        // Add to store
        for (const s of rawSlots) {
            (0, employmentShiftTable_1.addRawSlotToShiftStore)(s, this.settings.getTimeZone(), this.tableDates, this.shiftStore, this.branch.id);
        }
        const options = {
            prevShift: prev,
            countAllPeriods: false,
            applyRestFieldToFirstPeriodOnly: false,
        };
        // Special treatment for linked and calc stats
        for (const s of rawSlots) {
            let shift = this.shiftStore.byId(s.ID.toString());
            if (!shift) {
                return;
            }
            // NOTE: Issues with Shift classes require use of "as".
            if (shift.isLinkedShift()) {
                let night, morning;
                if (shift.isMorningShift()) {
                    morning = shift;
                    night = this.shiftStore.byId(shift.getLinkedId());
                }
                else {
                    night = shift;
                    morning = this.shiftStore.byId(shift.getLinkedId());
                }
                if (morning && night) {
                    // Only calc stats for merged shift once, if both shift are in view.
                    if (morning.getId() === shift.getId()) {
                        return;
                    }
                    shift = (0, employmentShiftTable_1.mergeLinkedShifts)(morning, night);
                    options.countAllPeriods = true;
                    options.applyRestFieldToFirstPeriodOnly = true;
                }
            }
            this.summaryStats.handleShiftChange(shift, options);
        }
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
    }
    updateStatsOnRawSlotDelete(rawSlot, repeatDate) {
        if (!this.shiftStore || !this.summaryStats) {
            return;
        }
        let shift = this.shiftStore.byId(rawSlot.ID.toString());
        if (rawSlot.Repeat) {
            // For now, we get date of the repeat from the modal to delete only the "extracted" shift.
            // In the future, slot modal should pass the deleted slot entity / feId so we don't need to query.
            if (!repeatDate) {
                return;
            }
            const max = (0, table_1.endDateForPeriod)(repeatDate, periodTypes_1.default.DAY, "Asia/Tokyo");
            const res = this.shiftStore.query({ repeatTemplateId: rawSlot.ID.toString(), startDateMin: repeatDate, startDateMax: max });
            shift = res[0];
        }
        if (!shift) {
            return;
        }
        let statsShift = shift;
        const options = {
            isDelete: true,
            countAllPeriods: false,
        };
        // NOTE: Issues with Shift classes require use of "as".
        if (shift.isLinkedShift()) {
            let night, morning;
            if (shift.isMorningShift()) {
                morning = shift;
                night = this.shiftStore.byId(shift.getLinkedId());
            }
            else {
                night = shift;
                morning = this.shiftStore.byId(shift.getLinkedId());
            }
            if (morning && night) {
                // Only calc stats for merged shift once, if both shift are in view.
                if (morning.getId() === shift.getId()) {
                    return;
                }
                statsShift = (0, employmentShiftTable_1.mergeLinkedShifts)(morning, night);
                options.countAllPeriods = true;
            }
        }
        this.summaryStats.handleShiftChange(statsShift, options);
        if (statsShift.isMergedShift()) {
            this.shiftStore.delete(statsShift.getMorningShiftId());
            this.shiftStore.delete(statsShift.getNightShiftId());
            return;
        }
        this.shiftStore.delete(shift.getId());
    }
    async deleteCachedSlots(slotIds) {
        if (!this.slotDb) {
            return;
        }
        try {
            await this.slotDb.deleteBatchKeys(slotIds);
        }
        catch (e) {
            console.error(`Failed to delete cached slots: ${e}`);
        }
    }
    handleRawSlotDelete(rawSlot, oplusTimeUnix) {
        if (!rawSlot || !this.shiftStore || !this.summaryStats || !this.branch || !this.settings) {
            return;
        }
        // Update subject
        this.slots.delete(rawSlot.ID);
        // Present
        const repeatDate = oplusTimeUnix ? (0, common_1.fromOplusTime)(new Date(oplusTimeUnix * 1000)) : undefined;
        this.updateStatsOnRawSlotDelete(rawSlot, repeatDate);
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(rawSlot, this.settings.getTimeZone(), repeatDate);
        // Must remove from cells map before slot map
        for (const d of dates) {
            if (this.cellsMap.value[rawSlot.UserID][d]) {
                delete this.cellsMap.value[rawSlot.UserID][d].slots[rawSlot.ID];
            }
        }
        if (!rawSlot.Repeat) {
            delete this.slotMap[rawSlot.ID];
            (0, summary_lib_1.setSlotMap)(this.slotMap);
        }
        // Do not await.
        this.deleteCachedSlots([rawSlot.ID]);
    }
    // cacheAllSlots will cache all of the slots in the this.slots map.
    // If the cache worker is available, it will prefer a series of batched background tasks.
    // If not, it will perform a single task on the main thread.
    async cacheAllSlots() {
        if (this.slotCacheWorker) {
            this.cacheSlotsBatchedBackground();
        }
        else {
            // Use main thread put.
            const allSlots = [];
            for (const [, s] of this.slots) {
                allSlots.push(s);
            }
            try {
                await (0, storageSummary_1.cacheSlots)(allSlots);
            }
            catch (e) {
                console.error(`Failed to cache all slots sync: ${e}`);
            }
        }
    }
    // handleRawSlotsLocked handles updating the slot subject and presenting slots after a bulk lock.
    // Currently the function assumes that a lock event is only a visual change, so stats are not computed.
    handleRawSlotsLocked(rawSlots) {
        const dashSlots = [];
        for (const rawSlot of rawSlots) {
            dashSlots.push(rawSlotToDashSlot(rawSlot));
            // Present
            this.slotMap[rawSlot.ID] = rawSlot;
            this.addSlotToCellsMapOnRawSlotChange(rawSlot);
        }
        this.addSlotsToSlotMap(dashSlots);
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        (0, summary_lib_1.toggleUnlockSlotBtn)(Object.values(this.slotMap));
        // Do not await.
        this.cacheAllSlots();
    }
    handleRawSlotDrag(rawSlot) {
        if (!this.settings || !this.branch) {
            return;
        }
        const prev = this.slotMap[rawSlot.ID];
        if (prev) {
            this.updateStatsOnRawSlotDelete(prev);
            const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(prev, this.settings.getTimeZone());
            for (const d of dates) {
                if (this.cellsMap.value[prev.UserID][d]) {
                    delete this.cellsMap.value[prev.UserID][d].slots[prev.ID];
                }
            }
        }
        const ss = rawSlotToDashSlot(rawSlot);
        this.slots.set(ss.id, ss);
        this.slotMap[ss.id] = rawSlot;
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        this.updateStatsOnRawSlotChange(rawSlot);
        this.addSlotToCellsMapOnRawSlotChange(rawSlot);
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        // Do not await.
        this.cacheSlot(ss);
    }
    handleRawSlotsBulkSelectedDelete(slotIds) {
        if (!this.branch || !this.settings) {
            return;
        }
        for (const id of slotIds) {
            const s = this.slotMap[id];
            if (s?.RequestedSlot) {
                // Restore initial requested slot.
                this.handleRawSlotChange(s.RequestedSlot);
            }
            this.slots.delete(id);
            if (s) {
                this.updateStatsOnRawSlotDelete(s);
                const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(s, this.settings.getTimeZone());
                // Must remove from cells map before slot map
                for (const d of dates) {
                    if (this.cellsMap.value[s.UserID][d]) {
                        delete this.cellsMap.value[s.UserID][d].slots[s.ID];
                    }
                }
            }
            delete this.slotMap[s.ID];
        }
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        // Do not await.
        this.deleteCachedSlots(slotIds);
    }
    handleRawSlotsBulkDelete(slotIds) {
        if (!this.branch || !this.settings) {
            return;
        }
        for (const id of slotIds) {
            this.slots.delete(id);
            const s = this.slotMap[id];
            if (s) {
                this.updateStatsOnRawSlotDelete(s);
            }
            delete this.slotMap[id];
        }
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        this.cellsMap.value = {};
        (0, employmentShiftTable_1.buildCellsMap)(this.cellsMap.value, this.slotMap, (0, common_1.toOplusTime)(this.tableDates[this.tableDates.length - 1].getDate()), this.query.isLocked ?? false, this.settings.splitNightShift, this.settings.getTimeZone());
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        // Do not await.
        this.deleteCachedSlots(slotIds);
    }
    initStats(users, slots) {
        if (!this.settings || !this.meStore || !this.roleStore || !this.branch) {
            return;
        }
        const empStore = (0, employmentShiftTable_1.newEmploymentStoreFromRaw)(users, this.branch?.id);
        this.employmentStore = empStore;
        const repeatMap = new Map();
        const shiftStore = new shiftStore_1.ShiftStore();
        for (const s of slots) {
            if (s.isRepeat) {
                const prev = repeatMap.get(s.id);
                // Final repeat instances should be cloned from the earliest repeat instance in view.
                if (prev && new Date(prev.from) < new Date(s.from)) {
                    continue;
                }
                repeatMap.set(s.id, s);
            }
            const rawSlot = dashSlotToRawShift(s, this.settings, this.tableDates[0].getDate(), this.tableDates[this.tableDates.length - 1].getEnd(), this.settings.getTimeZone());
            (0, employmentShiftTable_1.addRawSlotToShiftStore)(rawSlot, this.settings.getTimeZone(), this.tableDates, shiftStore, this.branch.id);
        }
        this.shiftStore = shiftStore;
        const stats = (0, employmentShiftTable_1.newSummaryStats)(this.roleStore, empStore, shiftStore, this.meStore, this.tableDates, this.settings, this.settings.getTimeZone(), this.useSectionWage);
        this.summaryStats = stats;
        for (const slotId in shiftStore.data) {
            const s = shiftStore.byId(slotId);
            const { shift, options, doNotCalcStats } = (0, employmentShiftTable_1.getShiftAndOptionsForStats)(s, shiftStore, this.settings.splitNightShift);
            if (doNotCalcStats) {
                continue;
            }
            stats.handleShiftChange(shift, options);
        }
    }
    provideMeStore(meStore) {
        this.meStore = meStore;
        this.viewApp.provide(provider_1.summaryTableMeStoreInjectKey, meStore);
    }
    provideUseShiftBorders(useShiftBorders) {
        // Not able to use inject keys
        this.viewApp.provide('useShiftBorders', useShiftBorders);
    }
    provideSlotLogMap(slotLogMap) {
        // Not able to use inject keys
        this.viewApp.provide('slotLogMap', (0, vue_1.computed)(() => slotLogMap));
    }
    provideCellEditMode(cellEditMode) {
        // Not able to use inject keys
        this.viewApp.provide('cellEditMode', (0, vue_1.computed)(() => cellEditMode));
    }
    provideDeleteMode(deleteMode) {
        // Not able to use inject keys
        this.viewApp.provide('deleteMode', (0, vue_1.computed)(() => deleteMode));
    }
    provideBranchSettings(branchSettings) {
        this.settings = branchSettings;
        this.viewApp.provide(provider_1.summaryTableBranchSettingsInjectKey, branchSettings);
    }
    provideRoleStore(roleStore) {
        this.roleStore = roleStore;
        this.viewApp.provide('roleStore', roleStore);
    }
    initPresentation() {
        const viewModel = (0, vue_1.ref)({
            employeeRows: [],
            oplusTimeDateStrings: [],
        });
        this.presenter.setViewModel(viewModel.value);
        // Adding readonly(), which stops view from mutating view model, causes ts to report error: is 'readonly' and cannot be assigned to the mutable type 'SummaryTableEmployeeRow[]'.
        // It's a known typescript quirk (https://stackoverflow.com/questions/62225769/inconsistency-with-typescript-readonly-type) but doesn't appear in other repos. I am assuming it's a config issue.
        // Ignoring the typescript check for now as ignoring it makes the view model readonly and there doesn't seem to be any resulting type issues.
        // @ts-ignore
        this.viewApp.provide(provider_1.summaryTableViewModelInjectKey, (0, vue_1.readonly)(viewModel));
        this.viewApp.provide(provider_1.summaryTableIsReadOnlyInjectKey, (0, vue_1.readonly)(this.isReadOnly));
    }
    initPresentationEmployeeRows(userRows) {
        if (!this.branch) {
            return;
        }
        // Remove "/summary" from path
        const path = document.location.pathname.replace(/\/summary/ig, "");
        this.presenter.initEmployeeRows(userRows, this.showMemo, path, this.branch.id);
    }
    // initPresentationStats is a temporary way for summary_lib to pass required BE and computed values.
    // In the future, getting these values will be handled internally.
    initPresentationStats(roles, branchSettings, lockStatsColumns, showUserAlertBadges) {
        this.presenter.initEmployeeStats(branchSettings, lockStatsColumns, showUserAlertBadges, roles);
    }
    mount() {
        this.viewApp.mount("#summary-table-app");
    }
}
exports.SummaryTableApp = SummaryTableApp;
function dashUserToRawEmployment(u) {
    return {
        ID: u.userId,
        BranchUser: {
            ID: u.branchUserId,
            BranchID: u.branchId,
            Wage: u.wage,
            Transport: u.transport,
            Memo: u.memo,
            Tags: u.tags.map(t => t.string),
            MaxMonthLaborMinutes: u.maxMonthLaborMinutes,
            MonthlyVacationLimit: u.maxMonthVacationDays,
            MinMonthLaborMinutes: u.minMonthLaborMinutes,
            Permission: "", // Unused on summary
            EmployeeID: "", // Unused on summary
            MonthlyLimit: 0, // Unused on summary
            BranchName: "", // Unused on summary
        }
    };
}
// sortUsers sorts the list of users into the passed order with remaining users appended to the end of list by name alphabetical asc.
function sortUsers(users, userIdOrder) {
    const userMap = new Map();
    for (const u of users) {
        userMap.set(u.userId, u);
    }
    const out = [];
    userIdOrder.forEach(id => {
        const u = userMap.get(id);
        if (!u) {
            return;
        }
        userMap.delete(id);
        out.push(u);
    });
    const help = [];
    // Remaining are help.
    for (const [, user] of userMap) {
        help.push(user);
    }
    // Sort help by name asc to match previous BE sorting.
    help.sort((a, b) => a.name > b.name ? 1 : -1);
    out.push(...help);
    return out;
}
const MAX_BATCH_SIZE = 1000;
const MAX_REQUEST_COUNT = 10;
async function fetchAllUsers(branchId, userIds) {
    const all = [];
    let requests = 0;
    for (let i = 0; i < userIds.length; i += MAX_BATCH_SIZE) {
        if (requests >= MAX_REQUEST_COUNT) {
            // Basic defensive code to stop from over-requesting.
            console.error("Reached maximum allowed user fetches.");
            break;
        }
        const batch = userIds.slice(i, i + MAX_BATCH_SIZE);
        const { dashUsers } = await (0, summary_1.getDashUsersForIds)(branchId, batch);
        all.push(...dashUsers);
        requests++;
    }
    return all;
}
async function fetchAllDashSlots(branchId, startDate, endDate, roleIds, lockedOnly) {
    const options = {
        branchId,
        fromGte: startDate,
        fromLt: endDate,
        lockedOnly,
        roleIds,
    };
    let requestCount = 0;
    let isDone = false;
    let cursor = "";
    const allSlots = [];
    // Basic defensive code to stop from over-requesting.
    while (!isDone && requestCount < MAX_REQUEST_COUNT) {
        const { slots, page } = await (0, summary_1.getSlots)(options, cursor);
        isDone = page.done;
        cursor = page.cursor;
        allSlots.push(...slots);
        requestCount++;
    }
    if (!isDone) {
        // Log an error for debugging.
        console.error("Reached maximum allowed slot fetches.");
    }
    return allSlots;
}
function calcSlotMap(slots) {
    const slotMap = {};
    for (const s of slots) {
        // Keep earliest repeat instance
        if (s.Repeat && new Date(slotMap[s.ID]?.From) < new Date(s.From)) {
            continue;
        }
        slotMap[s.ID] = s;
        if (s.SectionSlots) {
            for (const sec of s.SectionSlots) {
                slotMap[sec.ID] = sec;
            }
        }
    }
    return slotMap;
}
function dashSlotToShift(ds) {
    const req = {
        id: ds.id,
        type: ds.type,
        userId: ds.userId,
        branchId: ds.branchId,
        startDate: (0, common_1.fromOplusTime)(new Date(ds.from)),
        endDate: (0, common_1.fromOplusTime)(new Date(ds.to)),
    };
    const opt = {
        roleId: ds.roleId,
        roleName: ds.roleName,
        isEdited: ds.isEdited,
        isAuto: ds.isAuto,
        isTemplate: false,
        purpose: ds.purpose,
        updated: new Date(ds.updatedTimeUnix * 1000),
        created: new Date(ds.createdTimeUnix * 1000),
        hideFrom: ds.hideFrom,
        hideTo: ds.hideTo,
    };
    return new shift_2.Shift(req, opt);
}
function dashSlotToRawShift(ds, settings, startDate, endDate, tz) {
    const sections = [];
    for (const section of ds.sectionSlots) {
        sections.push(dashSlotToRawShift(section, settings, startDate, endDate, tz));
    }
    return {
        ID: ds.id,
        UserID: ds.userId,
        From: ds.from,
        To: ds.to,
        Type: ds.type,
        LinkPrev: ds.linkPrev,
        LinkNext: ds.linkNext,
        RoleID: ds.roleId,
        RoleName: ds.roleName,
        Sections: ds.sectionIds,
        CompanyID: ds.branchId,
        SectionSlots: sections,
        SectionParent: ds.parentSlotId,
        HideTo: ds.hideTo,
        HideFrom: ds.hideFrom,
        Rest: (0, common_1.durationToKitchenTime)(ds.rest, "minutes"),
        Repeat: ds.isRepeat,
        RepeatUntil: ds.repeatUntil,
        RepeatExclude: ds.repeatExclude,
        CreatedTime: ds.createdTime,
        CreatedTimeUnix: ds.createdTimeUnix,
        UpdatedTime: ds.updatedTime,
        UpdatedTimeUnix: ds.updatedTimeUnix,
        Purpose: ds.purpose,
        IsAuto: ds.isAuto,
        IsEdited: ds.isEdited,
        IsTemplate: false,
        Date: ds.date,
        RepeatLocked: ds.repeatLocked,
        CreatedBy: ds.createdBy,
        Wage: ds.wage,
        Color: ds.color,
        Locked: ds.isLocked,
        Memo: ds.memo,
        Label: ds.label,
        FromLabel: ds.fromLabel,
        FromUnix: ds.fromUnix,
        ToUnix: ds.toUnix,
        ToLabel: ds.toLabel,
        DateLabel: ds.dateLabel,
        DateUnix: ds.dateUnix,
        RequestedSlot: ds.requestedSlot ? dashSlotToRawShift(ds.requestedSlot, settings, startDate, endDate, tz) : undefined,
        Alert: ds.alert,
        AskStatus: ds.askStatus,
        IsHelp: ds.isHelp,
        KOTSynced: ds.isKotSynced,
        RequestedSlotKey: ds.requestedSlotKey,
        ManagedSlotKey: ds.managedSlotKey,
        RequestedSlotID: ds.requestedSlotId,
        ManagedSlotID: ds.managedSlotId,
        Text: (0, shift_1.shiftName)(dashSlotToShift(ds), settings, startDate, endDate, tz), // Required for sections in the SlotModal.
        NumComments: ds.numComments,
        IsRead: ds.isRead,
        CompanyName: ds.branchName, // Required for Help
    };
}
function filterUsersToWorkerOnly(users, slots) {
    const outUserIdSet = new Set();
    const workersOnly = [];
    const userMap = new Map();
    for (const u of users) {
        userMap.set(u.userId, u);
    }
    for (const s of slots) {
        if (outUserIdSet.has(s.userId) || (s.type !== models_1.SLOT_TYPES.HOURLY && s.type !== models_1.SLOT_TYPES.WORKDAY)) {
            continue;
        }
        const u = userMap.get(s.userId);
        if (!u) {
            continue;
        }
        workersOnly.push(u);
        outUserIdSet.add(s.userId);
    }
    return workersOnly;
}
// filterUsersToThoseWithRoleSlot expects a list of users and a list of role ids. Multiple role ids will result in OR operations, returning all users that have a slot of any role.
function filterUsersToThoseWithRoleSlot(users, slots, roleIds) {
    const outUserIdSet = new Set();
    const roleIdSet = new Set(roleIds);
    const out = [];
    const userMap = new Map();
    for (const u of users) {
        userMap.set(u.userId, u);
    }
    for (const s of slots) {
        if (outUserIdSet.has(s.userId) || !roleIdSet.has(s.roleId)) {
            continue;
        }
        const u = userMap.get(s.userId);
        if (!u) {
            continue;
        }
        out.push(u);
        outUserIdSet.add(s.userId);
    }
    return out;
}
// filterUsersByTags expects a list of users and a list of decoded tags. Multiple tags will result in OR operations, returning all users that match any tag.
function filterUsersByTags(users, userTags) {
    const outUserIdSet = new Set();
    const out = [];
    const userTagSet = new Set(userTags);
    for (const u of users) {
        if (outUserIdSet.has(u.userId)) {
            continue;
        }
        for (const tag of u.tags) {
            if (userTagSet.has(tag.string)) {
                out.push(u);
                outUserIdSet.add(u.userId);
                break;
            }
        }
    }
    return out;
}
// filterUsers takes a list of users, removes any hidden users, and filters the list based on filters.
// Combinations of different filters are treated as AND operations.
function filterUsers(users, slots, workerOnly, userTags, roleIds) {
    let out = users.filter(u => !u.isHiddenInShift);
    if (!workerOnly && !userTags.length && !roleIds.length) {
        return out;
    }
    if (workerOnly) {
        out = filterUsersToWorkerOnly(users, slots);
    }
    if (userTags.length) {
        out = filterUsersByTags(out, userTags);
    }
    if (roleIds.length) {
        out = filterUsersToThoseWithRoleSlot(out, slots, roleIds);
    }
    return out;
}
// calcStartDateForSlotFetch expects the start date for a given summary table table view, returning a re-computed date if splitNightShift setting is on.
function calcStartDateForSlotFetch(startDate, splitNightShift) {
    return splitNightShift ? luxon_1.DateTime.fromJSDate(startDate).minus({ days: 1 }).toJSDate() : startDate;
}
// calcUserIdsToFetch makes a list of user ids, always including all branch employees, adding in Help, and deduping
function calcUserIdsToFetch(employeeIds, slots) {
    // Always fetch all employees
    const userIdSet = new Set(employeeIds);
    for (const s of slots) {
        userIdSet.add(s.userId);
    }
    return [...userIdSet];
}
// calcTagsProp calculates a list of Tag entities used as props in various modals from a list of tags and decoded tags in location.search.
function calcTagsProp(tags, searchTags) {
    const out = [];
    const tagsSet = new Set();
    const selectedTags = new Set(searchTags);
    for (const t of tags) {
        if (tagsSet.has(t)) {
            continue;
        }
        tagsSet.add(t);
        out.push({
            decodedTag: t.string,
            selected: selectedTags.has(t.string),
            tag: t.encoded,
        });
    }
    return out;
}
// calcAppUserMap converts a list of users into the type required by the global App.userMap found in summary.html and required by the SlotModal in dashboard_base.html
function calcAppUserMap(users) {
    const userMap = {};
    for (const u of users) {
        userMap[u.userId] = {
            username: u.name,
        };
    }
    return userMap;
}
// parseSummaryQueryParams parses a URI encoded location.search string, returning relevant search params.
// Will ignore situations where the param key exists but the value is empty.
function parseSummaryQueryParams(searchString) {
    const out = {
        roleIds: [],
        customEncodingUserTags: []
    };
    const p = new URLSearchParams(searchString);
    const workerOnly = p.get("workerOnly");
    if (workerOnly) {
        out.workerOnly = workerOnly === "true";
    }
    const isLocked = p.get("lockedOnly");
    if (isLocked) {
        out.isLocked = isLocked === "true";
    }
    // Tags in search use custom encoding
    const tagsQ = p.get("tags");
    if (tagsQ) {
        for (const et of tagsQ.split(",")) {
            out.customEncodingUserTags.push(decodeURIComponent(et));
        }
    }
    const roleStr = p.get("roles");
    if (roleStr) {
        for (const id of roleStr.split(",")) {
            const n = parseInt(id);
            if (!n) {
                continue;
            }
            out.roleIds.push(n);
        }
    }
    return out;
}
// decodeTags expects a list of oplus custom encoding tags, returning a list of decoded strings.
function decodeTags(customEncodingTags, oplusTags) {
    const out = [];
    const customEncodingToDecodedTag = new Map();
    for (const t of oplusTags) {
        customEncodingToDecodedTag.set(t.encoded, t.string);
    }
    for (const customTag of customEncodingTags) {
        const decoded = customEncodingToDecodedTag.get(customTag);
        if (!decoded) {
            continue;
        }
        out.push(decoded);
    }
    return out;
}
function calcDedupedTagsListFromUsers(dashUsers) {
    const allUserTags = [];
    const tagSet = new Set();
    for (const u of dashUsers) {
        for (const t of u.tags) {
            if (tagSet.has(t.string)) {
                continue;
            }
            tagSet.add(t.string);
            allUserTags.push(t);
        }
    }
    return allUserTags;
}
// computeEditModeCellProps computes the grid props required by the edit mode.
function computeEditModeCellProps(dates, usersInOrder, tz) {
    const out = {};
    dates.forEach((date, dateIdx) => {
        const ds = (0, common_1.yearMonthDateString)((0, common_1.toOplusTime)(date.getDate()), tz);
        out[ds] = usersInOrder.map((userId, userIdx) => {
            const prevUserId = usersInOrder[userIdx - 1];
            const nextUserId = usersInOrder[userIdx + 1];
            const prevDate = dates[dateIdx - 1];
            const nextDate = dates[dateIdx + 1];
            return {
                userId: userId,
                prevUserId: prevUserId ? prevUserId : 0,
                nextUserId: nextUserId ? nextUserId : 0,
                prevDate: prevDate ? (0, common_1.yearMonthDateString)((0, common_1.toOplusTime)(prevDate.getDate()), tz) : "",
                nextDate: nextDate ? (0, common_1.yearMonthDateString)((0, common_1.toOplusTime)(nextDate.getDate()), tz) : "",
            };
        });
    });
    return out;
}
function rawSlotToDashSlot(raw) {
    const sectionSlots = [];
    if (raw.SectionSlots) {
        for (const section of raw.SectionSlots) {
            sectionSlots.push(rawSlotToDashSlot(section));
        }
    }
    return {
        id: raw.ID,
        from: raw.From,
        to: raw.To,
        type: raw.Type,
        purpose: raw.Purpose || "",
        hideFrom: raw.HideFrom,
        hideTo: raw.HideTo,
        isLocked: raw.Locked ?? false,
        rest: raw.Rest ? (0, common_1.kitchenTimeToDuration)(raw.Rest, "minutes") : 0,
        userId: raw.UserID,
        branchId: raw.CompanyID,
        askStatus: raw.AskStatus ?? 0,
        createdTimeUnix: raw.CreatedTimeUnix ?? 0,
        updatedTimeUnix: raw.UpdatedTimeUnix ?? 0,
        color: raw.Color || "",
        commentCount: raw.NumComments ?? 0,
        sectionIds: raw.Sections ?? [],
        sectionSlots: sectionSlots,
        parentSlotId: raw.SectionParent ?? 0,
        isAuto: raw.IsAuto ?? false,
        isEdited: raw.IsEdited ?? false,
        isHelp: raw.IsHelp ?? false,
        isRead: raw.IsRead ?? false,
        isKotSynced: raw.KOTSynced ?? false,
        memo: raw.Memo ?? "",
        numComments: raw.NumComments ?? 0,
        roleId: raw.RoleID ?? 0,
        linkPrev: raw.LinkPrev ?? 0,
        linkNext: raw.LinkNext ?? 0,
        isRepeat: raw.Repeat,
        createdBy: raw.CreatedBy ?? 0,
        wage: raw.Wage ?? 0,
        alert: raw.Alert ?? 0,
        repeatUntil: raw.RepeatUntil,
        repeatExclude: raw.RepeatExclude ?? [],
        repeatLocked: raw.RepeatLocked ?? [],
        requestedSlotId: raw.RequestedSlotID ?? 0,
        requestedSlot: raw.RequestedSlot ? rawSlotToDashSlot(raw.RequestedSlot) : null,
        managedSlotId: raw.ManagedSlotID ?? 0,
        label: raw.Label || "",
        fromLabel: raw.FromLabel || "",
        fromUnix: raw.FromUnix || 0,
        toUnix: raw.ToUnix || 0,
        toLabel: raw.ToLabel ?? "",
        date: raw.Date,
        dateLabel: raw.DateLabel ?? "",
        dateUnix: raw.DateUnix ?? "",
        roleName: raw.RoleName ?? "",
        userName: "", // Deprecated. Unused.
        branchName: raw.CompanyName ?? "",
        createdTime: raw.CreatedTime ?? "",
        updatedTime: raw.UpdatedTime ?? "",
        requestedSlotKey: raw.RequestedSlotKey ?? "",
        managedSlotKey: raw.ManagedSlotKey ?? "",
    };
}
// NOTE: Issues with Shift classes require use of "as".
function getShiftForStatsFromShiftStore(id, shiftStore) {
    let shift = shiftStore.byId(id.toString());
    // Linked slots require special treatment for stats calculations.
    if (shift && shift.isLinkedShift()) {
        let night, morning;
        if (shift.isMorningShift()) {
            morning = shift;
            night = shiftStore.byId(shift.getLinkedId());
        }
        else {
            night = shift;
            morning = shiftStore.byId(shift.getLinkedId());
        }
        if (morning && night) {
            shift = (0, employmentShiftTable_1.mergeLinkedShifts)(morning, night);
        }
    }
    return shift;
}
function computeRoleCountData(pipelineValue) {
    const out = {
        rolesCount: {},
    };
    for (const role of pipelineValue) {
        const dates = {};
        for (const date of role.Dates) {
            dates[date.String] = {
                Required: date.Required,
            };
        }
        out.rolesCount[role.Role.ID] = {
            dates,
        };
    }
    return out;
}
function calcSlotsToDelete(slots, cachedSlots) {
    const freshSlots = new Set();
    for (const s of slots) {
        freshSlots.add(s.id);
    }
    const slotsToDelete = new Set();
    // Slots are hard deleted so a comparison of full set is required to remove deleted slots from cache.
    for (const [, cachedSlot] of cachedSlots) {
        if (freshSlots.has(cachedSlot.id)) {
            continue;
        }
        slotsToDelete.add(cachedSlot.id);
    }
    return [...slotsToDelete];
}
